// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as RoutesRouteImport } from './routes/routes'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForSuppliersRouteImport } from './routes/for-suppliers'
import { Route as ForPartnersRouteImport } from './routes/for-partners'
import { Route as ForBusinessesRouteImport } from './routes/for-businesses'
import { Route as FleetRouteImport } from './routes/fleet'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BusinessSignupRouteImport } from './routes/business-signup'
import { Route as BookingRouteImport } from './routes/booking'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TransfersMarrakechToTaghazoutTamraghtRouteImport } from './routes/transfers.marrakech-to-taghazout-tamraght'
import { Route as TransfersMarrakechToEssaouiraRouteImport } from './routes/transfers.marrakech-to-essaouira'
import { Route as TransfersMarrakechToAgadirRouteImport } from './routes/transfers.marrakech-to-agadir'
import { Route as TransfersEssaouiraToImsouaneTaghazoutRouteImport } from './routes/transfers.essaouira-to-imsouane-taghazout'
import { Route as TransfersAgadirToTaghazoutSurfRouteImport } from './routes/transfers.agadir-to-taghazout-surf'
import { Route as TransfersAgadirTaghazoutToImsouaneRouteImport } from './routes/transfers.agadir-taghazout-to-imsouane'
import { Route as TransfersAgadirAirportToTaghazoutTamraghtRouteImport } from './routes/transfers.agadir-airport-to-taghazout-tamraght'
import { Route as TransfersAgadirAirportToImsouaneSurfRouteImport } from './routes/transfers.agadir-airport-to-imsouane-surf'
import { Route as TransfersAgadirAirportToEssaouiraRouteImport } from './routes/transfers.agadir-airport-to-essaouira'
import { Route as TransferSlugRouteImport } from './routes/transfer.$slug'
import { Route as BusinessSignupThanksRouteImport } from './routes/business-signup_.thanks'
import { Route as PartnerIndexRouteImport } from './routes/partner.index'
import { Route as PartnerSettingsRouteImport } from './routes/partner.settings'
import { Route as PartnerFleetRouteImport } from './routes/partner.fleet'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminVehiclesRouteImport } from './routes/admin.vehicles'
import { Route as AdminSuppliersRouteImport } from './routes/admin.suppliers'
import { Route as AdminQualityMetricsRouteImport } from './routes/admin.quality-metrics'
import { Route as AdminPartnersRouteImport } from './routes/admin.partners'
import { Route as AdminOffersRouteImport } from './routes/admin.offers'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminInvoicesRouteImport } from './routes/admin.invoices'
import { Route as AdminFleetsRouteImport } from './routes/admin.fleets'
import { Route as AdminEventLogsRouteImport } from './routes/admin.event-logs'
import { Route as AdminDriversRouteImport } from './routes/admin.drivers'
import { Route as AdminCompanyProfileRouteImport } from './routes/admin.company-profile'
import { Route as AdminCityCoveragesRouteImport } from './routes/admin.city-coverages'
import { Route as AdminArticlesRouteImport } from './routes/admin.articles'
import { Route as PartnerOrdersOrderIdRouteImport } from './routes/partner.orders.$orderId'
import { Route as BookingStatusIdRouteImport } from './routes/booking.status.$id'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const RoutesRoute = RoutesRouteImport.update({
            id: '/routes',path: '/routes',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForSuppliersRoute = ForSuppliersRouteImport.update({
            id: '/for-suppliers',path: '/for-suppliers',getParentRoute: () => rootRouteImport
          })
const ForPartnersRoute = ForPartnersRouteImport.update({
            id: '/for-partners',path: '/for-partners',getParentRoute: () => rootRouteImport
          })
const ForBusinessesRoute = ForBusinessesRouteImport.update({
            id: '/for-businesses',path: '/for-businesses',getParentRoute: () => rootRouteImport
          })
const FleetRoute = FleetRouteImport.update({
            id: '/fleet',path: '/fleet',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BusinessSignupRoute = BusinessSignupRouteImport.update({
            id: '/business-signup',path: '/business-signup',getParentRoute: () => rootRouteImport
          })
const BookingRoute = BookingRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TransfersMarrakechToTaghazoutTamraghtRoute = TransfersMarrakechToTaghazoutTamraghtRouteImport.update({
            id: '/transfers/marrakech-to-taghazout-tamraght',path: '/transfers/marrakech-to-taghazout-tamraght',getParentRoute: () => rootRouteImport
          })
const TransfersMarrakechToEssaouiraRoute = TransfersMarrakechToEssaouiraRouteImport.update({
            id: '/transfers/marrakech-to-essaouira',path: '/transfers/marrakech-to-essaouira',getParentRoute: () => rootRouteImport
          })
const TransfersMarrakechToAgadirRoute = TransfersMarrakechToAgadirRouteImport.update({
            id: '/transfers/marrakech-to-agadir',path: '/transfers/marrakech-to-agadir',getParentRoute: () => rootRouteImport
          })
const TransfersEssaouiraToImsouaneTaghazoutRoute = TransfersEssaouiraToImsouaneTaghazoutRouteImport.update({
            id: '/transfers/essaouira-to-imsouane-taghazout',path: '/transfers/essaouira-to-imsouane-taghazout',getParentRoute: () => rootRouteImport
          })
const TransfersAgadirToTaghazoutSurfRoute = TransfersAgadirToTaghazoutSurfRouteImport.update({
            id: '/transfers/agadir-to-taghazout-surf',path: '/transfers/agadir-to-taghazout-surf',getParentRoute: () => rootRouteImport
          })
const TransfersAgadirTaghazoutToImsouaneRoute = TransfersAgadirTaghazoutToImsouaneRouteImport.update({
            id: '/transfers/agadir-taghazout-to-imsouane',path: '/transfers/agadir-taghazout-to-imsouane',getParentRoute: () => rootRouteImport
          })
const TransfersAgadirAirportToTaghazoutTamraghtRoute = TransfersAgadirAirportToTaghazoutTamraghtRouteImport.update({
            id: '/transfers/agadir-airport-to-taghazout-tamraght',path: '/transfers/agadir-airport-to-taghazout-tamraght',getParentRoute: () => rootRouteImport
          })
const TransfersAgadirAirportToImsouaneSurfRoute = TransfersAgadirAirportToImsouaneSurfRouteImport.update({
            id: '/transfers/agadir-airport-to-imsouane-surf',path: '/transfers/agadir-airport-to-imsouane-surf',getParentRoute: () => rootRouteImport
          })
const TransfersAgadirAirportToEssaouiraRoute = TransfersAgadirAirportToEssaouiraRouteImport.update({
            id: '/transfers/agadir-airport-to-essaouira',path: '/transfers/agadir-airport-to-essaouira',getParentRoute: () => rootRouteImport
          })
const TransferSlugRoute = TransferSlugRouteImport.update({
            id: '/transfer/$slug',path: '/transfer/$slug',getParentRoute: () => rootRouteImport
          })
const BusinessSignupThanksRoute = BusinessSignupThanksRouteImport.update({
            id: '/business-signup_/thanks',path: '/business-signup/thanks',getParentRoute: () => rootRouteImport
          })
const PartnerIndexRoute = PartnerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PartnerRoute
          })
const PartnerSettingsRoute = PartnerSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => PartnerRoute
          })
const PartnerFleetRoute = PartnerFleetRouteImport.update({
            id: '/fleet',path: '/fleet',getParentRoute: () => PartnerRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminVehiclesRoute = AdminVehiclesRouteImport.update({
            id: '/vehicles',path: '/vehicles',getParentRoute: () => AdminRoute
          })
const AdminSuppliersRoute = AdminSuppliersRouteImport.update({
            id: '/suppliers',path: '/suppliers',getParentRoute: () => AdminRoute
          })
const AdminQualityMetricsRoute = AdminQualityMetricsRouteImport.update({
            id: '/quality-metrics',path: '/quality-metrics',getParentRoute: () => AdminRoute
          })
const AdminPartnersRoute = AdminPartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => AdminRoute
          })
const AdminOffersRoute = AdminOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AdminRoute
          })
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AdminRoute
          })
const AdminFleetsRoute = AdminFleetsRouteImport.update({
            id: '/fleets',path: '/fleets',getParentRoute: () => AdminRoute
          })
const AdminEventLogsRoute = AdminEventLogsRouteImport.update({
            id: '/event-logs',path: '/event-logs',getParentRoute: () => AdminRoute
          })
const AdminDriversRoute = AdminDriversRouteImport.update({
            id: '/drivers',path: '/drivers',getParentRoute: () => AdminRoute
          })
const AdminCompanyProfileRoute = AdminCompanyProfileRouteImport.update({
            id: '/company-profile',path: '/company-profile',getParentRoute: () => AdminRoute
          })
const AdminCityCoveragesRoute = AdminCityCoveragesRouteImport.update({
            id: '/city-coverages',path: '/city-coverages',getParentRoute: () => AdminRoute
          })
const AdminArticlesRoute = AdminArticlesRouteImport.update({
            id: '/articles',path: '/articles',getParentRoute: () => AdminRoute
          })
const PartnerOrdersOrderIdRoute = PartnerOrdersOrderIdRouteImport.update({
            id: '/orders/$orderId',path: '/orders/$orderId',getParentRoute: () => PartnerRoute
          })
const BookingStatusIdRoute = BookingStatusIdRouteImport.update({
            id: '/status/$id',path: '/status/$id',getParentRoute: () => BookingRoute
          })





const AdminRouteChildren = {
  AdminArticlesRoute: AdminArticlesRoute,AdminCityCoveragesRoute: AdminCityCoveragesRoute,AdminCompanyProfileRoute: AdminCompanyProfileRoute,AdminDriversRoute: AdminDriversRoute,AdminEventLogsRoute: AdminEventLogsRoute,AdminFleetsRoute: AdminFleetsRoute,AdminInvoicesRoute: AdminInvoicesRoute,AdminLoginRoute: AdminLoginRoute,AdminOffersRoute: AdminOffersRoute,AdminPartnersRoute: AdminPartnersRoute,AdminQualityMetricsRoute: AdminQualityMetricsRoute,AdminSuppliersRoute: AdminSuppliersRoute,AdminVehiclesRoute: AdminVehiclesRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const BookingRouteChildren = {
  BookingStatusIdRoute: BookingStatusIdRoute
}

const BookingRouteWithChildren = BookingRoute._addFileChildren(BookingRouteChildren)




const PartnerRouteChildren = {
  PartnerFleetRoute: PartnerFleetRoute,PartnerSettingsRoute: PartnerSettingsRoute,PartnerIndexRoute: PartnerIndexRoute,PartnerOrdersOrderIdRoute: PartnerOrdersOrderIdRoute
}

const PartnerRouteWithChildren = PartnerRoute._addFileChildren(PartnerRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,AdminRoute: AdminRouteWithChildren,BlogRoute: BlogRouteWithChildren,BookingRoute: BookingRouteWithChildren,BusinessSignupRoute: BusinessSignupRoute,ContactRoute: ContactRoute,FleetRoute: FleetRoute,ForBusinessesRoute: ForBusinessesRoute,ForPartnersRoute: ForPartnersRoute,ForSuppliersRoute: ForSuppliersRoute,LoginRoute: LoginRoute,PartnerRoute: PartnerRouteWithChildren,RoutesRoute: RoutesRoute,UnsubscribeRoute: UnsubscribeRoute,BusinessSignupThanksRoute: BusinessSignupThanksRoute,TransferSlugRoute: TransferSlugRoute,TransfersAgadirAirportToEssaouiraRoute: TransfersAgadirAirportToEssaouiraRoute,TransfersAgadirAirportToImsouaneSurfRoute: TransfersAgadirAirportToImsouaneSurfRoute,TransfersAgadirAirportToTaghazoutTamraghtRoute: TransfersAgadirAirportToTaghazoutTamraghtRoute,TransfersAgadirTaghazoutToImsouaneRoute: TransfersAgadirTaghazoutToImsouaneRoute,TransfersAgadirToTaghazoutSurfRoute: TransfersAgadirToTaghazoutSurfRoute,TransfersEssaouiraToImsouaneTaghazoutRoute: TransfersEssaouiraToImsouaneTaghazoutRoute,TransfersMarrakechToAgadirRoute: TransfersMarrakechToAgadirRoute,TransfersMarrakechToEssaouiraRoute: TransfersMarrakechToEssaouiraRoute,TransfersMarrakechToTaghazoutTamraghtRoute: TransfersMarrakechToTaghazoutTamraghtRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)